import { useLocale, useT } from "../i18n";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { localized, useSiteSettings } from "../lib/siteSettings";
import ja from "../i18n/ja";

// [i18n row key, settings.company key | fixed value]
const ROWS = [
  ["name", null, "HAROON TRADING 合同会社"],
  ["corporateNumber", "corporate_number"],
  ["representative", "representative"],
  ["established", "established"],
  ["capital", "capital"],
  ["address", "address"],
  ["phone", "phone"],
  ["business", "business"],
  ["license", "license"],
  ["website", null, "haroontrading.net"],
];

export default function CompanyPage() {
  const t = useT();
  const lang = useLocale();
  const { company } = useSiteSettings();
  return (
    <div data-testid="company-page">
      <Seo title={t("pages.company.title")} description={t("pages.company.description")} path="company" />
      <section className="bg-ink pb-20 pt-40 text-white lg:pb-28 lg:pt-52">
        <Reveal className="container-x">
          <p className="eyebrow flex items-center gap-4 text-white/55">
            <span className="h-px w-8 bg-current" aria-hidden />
            {t("company.eyebrow")}
          </p>
          <h1 className="h-hero font-display mt-6" data-testid="page-title">{t("company.profileTitle")}</h1>
        </Reveal>
      </section>
      <section className="bg-white py-20 text-ink lg:py-32">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <p className="eyebrow opacity-50 lg:col-span-3">{lang === "en" ? "会社概要" : "Company Profile"}</p>
          <dl className="border-t border-ink/15 lg:col-span-9" data-testid="company-profile-table">
            {ROWS.map(([key, field, fixed]) => {
              const value = fixed || localized(company?.[field], lang);
              return (
                <div key={key} className="grid gap-2 border-b border-ink/15 py-6 sm:grid-cols-[14rem_1fr] sm:gap-8" data-testid={`company-row-${key}`}>
                  <dt className="text-sm text-ink/55">
                    {t(`company.rows.${key}`)}
                    {lang === "en" && <span className="ml-2 inline-block whitespace-nowrap text-ink/35">{ja.company.rows[key]}</span>}
                  </dt>
                  <dd className={value ? "whitespace-pre-line text-base" : "text-base text-ink/40"}>
                    {value || (
                      <span data-testid={`company-placeholder-${key}`}>
                        {t("ui.toBeProvided")}
                        {lang === "en" && <span className="ml-2">/ 準備中</span>}
                      </span>
                    )}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>
      </section>
    </div>
  );
}
